// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d5063b18","732":"3206d6fa","977":"36f0d88b"}[chunkId] + ".chunk.js";
};